import { render, staticRenderFns } from "./BrainstormEditItem.vue?vue&type=template&id=ca74de80&scoped=true&"
import script from "./BrainstormEditItem.vue?vue&type=script&lang=js&"
export * from "./BrainstormEditItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca74de80",
  null
  
)

export default component.exports